/** flash.text.TextFormat: every property is nullable (null = "not specified" / mixed). */
export class TextFormat {
  font: string | null;
  size: any;
  color: any;
  bold: any;
  italic: any;
  underline: any;
  url: string | null;
  target: string | null;
  align: string | null;
  leftMargin: any;
  rightMargin: any;
  indent: any;
  leading: any;
  letterSpacing: any;
  kerning: any;
  blockIndent: any;
  bullet: any;
  tabStops: any;
  display: string | null;

  constructor(
    font: string | null = null,
    size: any = null,
    color: any = null,
    bold: any = null,
    italic: any = null,
    underline: any = null,
    url: string | null = null,
    target: string | null = null,
    align: string | null = null,
    leftMargin: any = null,
    rightMargin: any = null,
    indent: any = null,
    leading: any = null,
  ) {
    this.font = font;
    this.size = size;
    this.color = color;
    this.bold = bold;
    this.italic = italic;
    this.underline = underline;
    this.url = url;
    this.target = target;
    this.align = align;
    this.leftMargin = leftMargin;
    this.rightMargin = rightMargin;
    this.indent = indent;
    this.leading = leading;
    this.letterSpacing = null;
    this.kerning = null;
    this.blockIndent = null;
    this.bullet = null;
    this.tabStops = null;
    this.display = null;
  }
}

export const TextFieldType = { INPUT: 'input', DYNAMIC: 'dynamic' } as { INPUT: 'input'; DYNAMIC: 'dynamic' };
export const TextFieldAutoSize = { NONE: 'none', LEFT: 'left', CENTER: 'center', RIGHT: 'right' } as {
  NONE: 'none';
  LEFT: 'left';
  CENTER: 'center';
  RIGHT: 'right';
};
export const TextFormatAlign = { LEFT: 'left', CENTER: 'center', RIGHT: 'right', JUSTIFY: 'justify' } as {
  LEFT: 'left';
  CENTER: 'center';
  RIGHT: 'right';
  JUSTIFY: 'justify';
};
export const AntiAliasType = { ADVANCED: 'advanced', NORMAL: 'normal' } as const;
export const GridFitType = { NONE: 'none', PIXEL: 'pixel', SUBPIXEL: 'subpixel' } as const;
